/* eslint-disable no-restricted-properties */
import { assign, each, isEmpty, isInteger, isFinite, isNumber, cloneDeep, has, concat, union, keys, filter, isNil, join } from 'lodash';

export function getProperty(object, propertyName) {
  const parts = propertyName.split('.');
  const length = parts.length;

  let property = object || '';
  let i;
  for (i = 0; i < length; i += 1) {
    property = property[parts[i]];
  }

  return property;
}

export function firstTwoUpper(text) {
  let towUpper = '';
  let tmp;

  if (text === undefined || text === null || text === '') return towUpper;

  if (text.indexOf(' ') !== -1) {
    tmp = text.replace(/,/g, '').split(' ');

    const first = tmp[0].replace(/[^0-9a-z]/gi, '').substring(0, 1).toUpperCase();
    const second = tmp[1].replace(/[^0-9a-z]/gi, '').substring(0, 1).toUpperCase();

    towUpper = first + second;
  } else {
    towUpper = text.substring(0, 2).toUpperCase();
  }

  return towUpper;
}

export function filterPagesByAttributes(fun, pages, result) {
  if (typeof fun !== 'function') throw new TypeError();
  each(pages, (page) => {
    if (fun.call(fun, page, this)) {
      const found = assign({}, page, { pages: [] });
      if (page.pages && !isEmpty(page.pages)) {
        filterPagesByAttributes(fun, page.pages, found.pages);
      }
      result.push(found);
      return true;
    }
    return true;
  });
}

export const extractChildren = (fun, source, key) => {
  if (typeof fun !== 'function') throw new TypeError();
  let results = [];
  const search = (source, fun) => {
    each(source, (item) => {
      if (fun.call(fun, item, this)) {
        const obj = cloneDeep(item);
        results = concat(results, obj[key]);
        return;
      }
      if (has(item, key)) search(item[key], fun);
    });
  };
  search(source, fun);
  return results;
};

export const removeEmpty = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') removeEmpty(obj[key]);
    else if (obj[key] === undefined || obj[key] === null || obj[key] === '') delete obj[key];
  });
  return obj;
};

export const findListOfIDs = (result, array, key, value, childs) => {
  each(array, (item) => {
    let notFound = true;

    console.log('item', item[key], value);

    if (item[key] === value) {
      result.push(item[key]);
      console.log('found ', item[key]);
      notFound = false;
    }

    if (notFound && !isEmpty(item[childs])) {
      notFound = findListOfIDs(result, item[childs], key, value, childs);
      if (!notFound) {
        result.push(item[key]);
        console.log('found ', item[key]);
      }
    }

    return notFound;
  });
};

export const formatTime = (time) => {
  let formatedTime = '';
  if (time === undefined || time === null || time === '') return formatedTime;
  if (time.indexOf(':') !== -1) {
    const tmp = time.split(':');
    if (tmp.length >= 2) formatedTime = `${tmp[0]}:${tmp[1]}`;
  }
  return formatedTime;
};

export const toFixedFix = (n, prec) => {
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  const k = Math.pow(10, prec);
  return Math.round(n * k) / k;
};

export const numberFormat = (value, decimals, decPoint, thousandsSep) => {
  // if not set take 3 decimals
  decimals = isNumber(decimals) ? decimals : 1;

  const number = Number(value);

  // special case for integer, no decimals!
  if (isInteger(number)) decimals = 0;

  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = (typeof thousandsSep === 'undefined') ? '.' : thousandsSep;
  const dec = (typeof decPoint === 'undefined') ? ',' : decPoint;

  const s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array((prec - s[1].length) + 1).join('0');
  }

  return s.join(dec);
};

export const splitByComma = (value, type, count = 10) => {
  if (isNil(value) || value === '') return '';

  type = type || 'title';

  let text = '';
  const index = value.indexOf(',');

  if (index !== -1 && value.length > count) {
    const title = value.substring(0, index).trim();
    const subTitle = value.substring(index + 1).trim();

    const finalTitle = title !== '' ? title : subTitle;
    const finalSubTitle = title !== '' ? subTitle : '';

    text = type === 'title' ? finalTitle : finalSubTitle;
  } else {
    text = type === 'title' ? value.trim() : '';
  }

  return text;
};

export const changedKeys = (o1, o2) => {
  const keysList = union(keys(o1), keys(o2));
  return filter(keysList, key => o1[key] !== o2[key]);
};

export const findElementChild = (idOfElement, idOfChild) => {
  const element = document.getElementById(idOfElement);
  console.log('element', element);
  return element.querySelector(`[id=${idOfChild}]`);
};

export const toTitleCase = str => str.replace(/([^\W_]+[^\s-]*) */g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

export const capitalize = str => (str && str !== '' ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '');

export const getSubdomain = () => {
  let subdomain = null;
  const host = window.location.host;
  const splited = host.split('.');
  if (splited.length > 2) {
    subdomain = splited[0];
  }
  return subdomain;
};

export const replaceSubdomainInLocation = (replacement) => {
  const host = window.location.host;
  const protocol = window.location.protocol;

  let subdomain = host;

  const splited = host.split('.');
  if (splited.length > 2) {
    splited[0] = replacement;
    subdomain = join(splited, '.');
  }

  return `${protocol}//${subdomain}`;
};



// WEBPACK FOOTER //
// ./src/utils/index.js